import React from 'react'
import PropTypes from 'prop-types'
import EditIconSvg from 'static/icons/EditIconSvg'
import DeleteIconSvg from 'static/icons/DeleteIconSvg'

const propTypes = {
  style: PropTypes.object,
  handleDelete: PropTypes.func,
  handleEdit: PropTypes.func,
  rowData: PropTypes.object,
  isEdit: PropTypes.bool,
  isDelete: PropTypes.bool,
  isDisableDelete: PropTypes.bool
}

const editDeleteAction = ({
  style,
  isDisableDelete,
  handleDelete,
  handleEdit,
  isEdit,
  isDelete,
  rowData,
  ...restProps
}) => {
  return (
    <div style={{ display: 'flex', maxWidth: '4rem', cursor: 'pointer' }}>
      {isEdit && (
        <span onClick={() => handleEdit(rowData)} style={{ marginRight: '10px' }}>
          <EditIconSvg {...restProps} />
        </span>
      )}
      {isDelete && (
        <span style={isDisableDelete ? {pointerEvents: 'none', opacity: '.4', cursor: 'not-allowed'} : {}} onClick={() => handleDelete(rowData)}>
          <DeleteIconSvg {...restProps} />
        </span>
      )}
    </div>
  )
}

editDeleteAction.defaultProps = {
  isEdit: true,
  isDelete: true,
  isDisableDelete: false
}
editDeleteAction.propTypes = propTypes
export default editDeleteAction